<template>
  <div :class="classStyle">{{formated_value}}</div>
</template>

<script>
export default {
  name: 'Kpivalue',
  props: ['value', 'decimals', 'decimal_separator', 'thousand_separators', 'units', 'classStyle', 'region', 'symbol_position'],
  computed: {
    formated_value () {
      let val = this.value.toFixed(this.decimals);
      let splitval = val.split('.');
      let totalvalue = splitval[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousand_separators);
      if (splitval.length === 2) {
        totalvalue = totalvalue + this.decimal_separator + splitval[1];
      }
      if (this.position === 'prefix') { return this.symbol + ' ' + totalvalue; }
      return totalvalue + ' ' + this.symbol;
    },
    symbol () {
      if (this.units === 'currency') { return this.currency_dict[this.region]; } else if (this.units === 'percent') { return '%'; }
      return '';
    },
    position () {
      if (!this.symbol_position) { return 'suffix'; }
      return this.symbol_position;
    }
  },
  data () {
    return {
      currency_dict: {
        'es': '€',
        'en': '$'
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Kpi/Kpivalue.vue